import { Button } from '@components';
import { format, parseISO } from 'date-fns';

import br from 'date-fns/locale/pt-BR';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import { SuccessCard } from './SuccessCard';
import { HOME } from '../../common/utils/paths';

export const SolicitacaoSucessoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, protocolo, status, nomeRequerimento } = location.state;

  const dataFormatada = format(parseISO(data), "dd/MM/yyyy 'às' HH:mm", {
    locale: br,
  });

  return (
    <>
      <Helmet>
        <title>Forluz - {nomeRequerimento}</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-2">
        Solicitação de {nomeRequerimento}
      </h1>
      <hr />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32 mt-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(HOME)}
        >
          Voltar
        </Button>
      </div>

      <SuccessCard
        data={dataFormatada}
        protocolo={protocolo}
        status={status}
        nomeRequerimento={nomeRequerimento}
      />
    </>
  );
};
